export enum C3ProductType {
    Finished = 'Finished',
    Subassembly = 'Subassembly',
    ComponentGroup = 'Component Group',
}
